// extracted by mini-css-extract-plugin
export var closeButton = "_o9-2";
export var closeButtonIcon = "_o9-3";
export var lightboxContent = "_o9-1";
export var lightboxOverlay = "_o9-0";